import { useObraTiposObra } from "@/modules/obras";
import { mensagemAvisoTipos, mensagensRevisao } from "../../hooks/nova-obra.condicoes";
import { rotuloTipoPorCodigo } from "../../hooks/nova-obra.tipos";
import { useCondicoesObra } from "../../hooks/use-condicoes-obra";
import { formatDataBr } from "../format-data";

export function useAvisoLimitesTipos() {
  const { condicoes } = useCondicoesObra();
  const catalogo = useObraTiposObra();

  const texto = mensagemAvisoTipos(condicoes.limites, formatDataBr, (codigo) =>
    rotuloTipoPorCodigo(catalogo.data, codigo),
  );

  return { texto };
}

export function useMensagensRevisaoCondicoes() {
  const { condicoes } = useCondicoesObra();
  const catalogo = useObraTiposObra();

  const mensagens = mensagensRevisao(condicoes, formatDataBr, (codigo) =>
    rotuloTipoPorCodigo(catalogo.data, codigo),
  ).map((mensagem) => ({ ...mensagem, testId: `mensagem-revisao-${mensagem.chave}` }));

  return { mensagens };
}
